module.exports = __webpack_public_path__ + "img/a5f4df8.svg";